// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tBWF","newExpiryDate":"styles_newExpiryDate__2xweF","footer":"styles_footer__3-VVn"};